/** 
 * AOS init 
 */
jQuery(document).ready(function ($) {
    if (typeof AOS === 'undefined') {
        return;
    }

    AOS.init({
        startEvent: 'load',
    });

    $('img, video').on('load', function () {
        AOS.refresh();
    });
});
